import { h } from 'preact'
import Phrase from '../../../libs/translationsUtils/phrase'
import SearchResultsSection from './SearchResultsSection'
import HitContainerHeader from './HitContainerHeader'
import {Hit, DoSearch, GetItemPropsFn, AllSearchResults} from 'js/src/preact-components/algolia/components'
import SearchActionLink from './SearchActionLink'

const COMMUNITY_RESULTS = 0
const ZENDESK_RESULTS = 1

type FederatedHits = Array<{hits: Array<Hit>} | undefined>

interface Props {
  indexName: string,
  allSearchResults: AllSearchResults | null,
  inputValue: string,
  hits: FederatedHits,
  doSearch: DoSearch,
  highlightedIndex: number,
  getItemProps: GetItemPropsFn,
  style?: CSSStyleDeclaration,
  setHighlightedIndex: (idx: number | null) => void
}

const HitContainerWithFederated = ({
    indexName,
    allSearchResults,
    inputValue,
    hits,
    doSearch,
    highlightedIndex,
    getItemProps,
    setHighlightedIndex,
    style
  }: Props) => {

  const communityHits = hits[COMMUNITY_RESULTS]
  const zendeskHits = hits[ZENDESK_RESULTS]
  const hasResults = communityHits && communityHits.hits.length || zendeskHits && zendeskHits.hits.length

  const communitySearchMetadata = allSearchResults && allSearchResults[indexName]
  const zendeskSearchMetadata = allSearchResults && allSearchResults[`${indexName}-zendesk`]

  return <div key='results' className='algolia-hit-container' style={style}>
    <HitContainerHeader
      inputValue={inputValue}
      hasResults={!!hasResults}
      doSearch={doSearch}
    />

    { communitySearchMetadata && communityHits
      ? <SearchResultsSection
      title={<Phrase p='nav.title.community' />}
      type='community'
      searchMetadata={communitySearchMetadata}
      hits={communityHits.hits}
      highlightedIndex={highlightedIndex}
      getItemProps={getItemProps}
      previousResultsCount={0}
      setHighlightedIndex={setHighlightedIndex}
      viewAllUrl={`/search?q=${inputValue}`}
      /> : null }

    { zendeskSearchMetadata && zendeskHits && communityHits ? <SearchResultsSection
      title={<Phrase p='federated.search.zendesk' />}
      type='zendesk'
      searchMetadata={zendeskSearchMetadata}
      hits={zendeskHits.hits}
      highlightedIndex={highlightedIndex}
      getItemProps={getItemProps}
      setHighlightedIndex={setHighlightedIndex}
      previousResultsCount={communityHits.hits.length}
      viewAllUrl={`/search?search_type=zendesk&q=${inputValue}`}
    /> : null }

    <SearchActionLink icon='edit' href='/topic/new'>
      <Phrase p='live.search.ask.question' />
    </SearchActionLink>
  </div>
}

export default HitContainerWithFederated
